var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataEnriched({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9241 14.3456C28.8824 22.0775 22.5807 28.3799 14.8489 28.4223C7.11699 28.4648 0.882859 22.2313 0.924537 14.4994C0.966214 6.76756 7.26792 0.465205 14.9998 0.422735C22.7317 0.380264 28.9658 6.61376 28.9241 14.3456ZM2.32452 14.4917C2.28701 21.4504 7.89773 27.0606 14.8564 27.0223C21.8151 26.9841 27.4866 21.312 27.5241 14.3533C27.5616 7.39464 21.9509 1.78449 14.9922 1.82271C8.03356 1.86094 2.36203 7.53305 2.32452 14.4917Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36973 27.3176C11.2757 28.1548 13.3443 28.5564 15.4251 28.4932C17.5058 28.43 19.5463 27.9036 21.3979 26.9522C23.2495 26.0009 24.8656 24.6486 26.1287 22.9939C27.3917 21.3391 28.2698 19.4235 28.6991 17.3866C29.1284 15.3496 29.098 13.2426 28.6102 11.2188C28.1223 9.19511 27.1893 7.30563 25.8791 5.68799C24.5689 4.07034 22.9144 2.76524 21.0361 1.86772C19.1578 0.970189 17.103 0.502824 15.0213 0.49965L15 14.4996L9.36973 27.3176Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataEnriched);
export default __webpack_public_path__ + "static/media/DATA_ENRICHED.f50559e92d7fd0e3557a0ea9959ffca5.svg";
export { ForwardRef as ReactComponent };